import React from 'react';
import { isIOS } from 'react-device-detect';
import { Box, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import { LargePageLineText } from '../@common/PageLineText';
import BaseInput from '../@common/BaseInput';
import { WorksheetBaseProps } from '../@types';
import NameAndDateLines from '../@common/NameAndDateLines';
import GroupedPageLines from '../@common/GroupedPageLines';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

type WordsAndSpellingProps = WorksheetBaseProps & {
  value: string;
};

const VocabularyPrekto1 = ({ onChange, valueMap, printRef }: WordsAndSpellingProps) => {
  const bookFont = 'Print-Wide-Book';
  const numOfColsArray = [...Array(3).keys()];

  const classes = useStyles();

  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  const baseInputStyles: any = {
    fontFamily: bookFont,
    color: '#000',
    style: {
      fontSize: 60,
      width: 275,
      marginLeft: 40,
      marginTop: isIOS ? '-34.5px' : '-35px',
      color: '#000',
      position: 'relative !important',
      maxWidth: 900
    }
  };

  let itemNum = 0;

  const renderColumn = index => {
    return (
      <Grid item xs={4}>
        <Paper className={classes.paper}>
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <Box className={classes.box} />
          </Box>
          <Box style={{ marginTop: '70px' }} component={'li'}>
            <LargePageLineText>
              <div className={classes.pageNumber}>{itemNum}.</div>
              <BaseInput
                onChange={({ target }) => handleChange(index, target.value)}
                showBackground={true}
                {...baseInputStyles}
                placeholder={t('word')}
                fontSize={65}
                value={valueMap[index]}
                aria-label={`${t('word')} ${index}`}
              />
            </LargePageLineText>
            <GroupedPageLines width={275} isWide paddingTop={28} />
            <GroupedPageLines top={50} width={275} isWide paddingTop={30} />
          </Box>
        </Paper>
      </Grid>
    );
  };

  return (
    <LandscapePaperLayout isWide printRef={printRef}>
      <NameAndDateLines fontFamily={bookFont} isWide width={1000} top={2} />
      <div
        className={classes.root}
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          top: 162,
          margin: '50px 0',
          padding: '20px'
        }}
      >
        <Grid container spacing={1}>
          <Grid container item spacing={3} component={'ul'} style={{ listStyle: 'none' }}>
            {numOfColsArray.map((col, idx) => {
              itemNum++;
              const index = idx + 1;
              return renderColumn(index);
            })}
          </Grid>
        </Grid>
      </div>
    </LandscapePaperLayout>
  );
};

export default VocabularyPrekto1;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    textAlign: 'center',
    border: 'none',
    boxShadow: 'none'
  },
  pageNumber: {
    marginRight: -15
  },
  box: {
    border: '2px solid black',
    height: '300px',
    width: '300px'
  }
}));
